import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useCreateSupportTicketMutation } from '@src/services/support/supportApiSlice';
import { SupportTicketParams } from '@src/services/support/supportApiTypes';
import { useCheckResponse } from '@src/hooks';

export const useSupportForm = () => {
    const { t } = useTranslation();
    const { checkResponse } = useCheckResponse();
    const [createTicket, { isLoading }] = useCreateSupportTicketMutation();
    const [isSubmitted, setIsSubmitted] = useState(false);

    const onSubmit = async (formData: SupportTicketParams) => {
        try {
            const response = await createTicket(formData).unwrap();

            if (response) {
                setIsSubmitted(true);
                message.success(t('forms.support.submitSuccess'));
            }
        } catch (error: any) {
            checkResponse({ error });
        }
    };

    const resetForm = () => {
        setIsSubmitted(false);
    };

    return {
        isLoading,
        isSubmitted,
        onSubmit,
        resetForm,
    };
};
